module.exports = __webpack_public_path__ + "img/integral_store_bg.0235df12.png";